import { Input, InputProps } from "@chakra-ui/react";
import { ChangeEvent, CSSProperties, forwardRef } from "react";

interface SliderProps extends InputProps {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => any;
  min: number;
  max: number;
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ onChange, min, max, ...style }: SliderProps, ref) => {
    return (
      <Input
        {...style}
        variant="unstyled"
        ref={ref}
        background="gray.200"
        backgroundImage="linear-gradient(#00a88450, #00a88450)"
        backgroundSize="0% 100%"
        backgroundRepeat="no-repeat"
        border="none"
        h="6px"
        type="range"
        _hover={{}}
        sx={{
          "&::-webkit-slider-thumb": {
            WebkitAppearance: "none",
            height: "12px",
            width: "12px",
            borderRadius: "50%",
            cursor: "pointer",
            boxShadow: "0 0 2px 0 #555",
            transition: "0.3s",
            background: "#00a884",
          },
          "&::-webkit-slider-thumb:active": {
            transform: "scale(1.12)",
          },
          "&::-webkit-slider-runnable-track": {
            WebkitAppearance: "none",
            boxShadow: "none",
            border: "none",
            background: "transparent",
          },
        }}
        onChange={(e) => {
          e.target.readOnly = false;
          const progress =
            ((parseInt(e.target.value) - min) / (max - min)) * 100;
          e.target.style.backgroundSize = `${progress}% 100%`;
          onChange?.(e);
        }}
        onInput={(e) => {
          const progress =
            ((parseInt(e.currentTarget.value) - min) / (max - min)) * 100;
          e.currentTarget.style.backgroundSize = `${progress}% 100%`;
        }}
        min={min}
        max={max}
        defaultValue={min}
      />
    );
  }
);
